// extracted by mini-css-extract-plugin
export default {"external-link-icon":"external-link-icon---k77mq"};